import SvgIcon from '@mui/material/SvgIcon';

export default function SsoIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      {/* Cloud */}
      <path d="M18 10a4 4 0 0 0-7.9-1H10A5 5 0 0 0 5 14a4 4 0 0 0 1 7h10a4 4 0 0 0 2-7.5A4 4 0 0 0 18 10z"/>
      {/* Key */}
      <path d="M9 15a3 3 0 1 1 2.8-4H15v2h-1v1h-1v1H9z"/>
      {/* User */}
      <circle cx="7" cy="8" r="2"/>
      <path d="M7 11c-2 0-3.5 1.2-3.9 3h7.8C10.5 12.2 9 11 7 11z"/>
    </SvgIcon>
  );
}
